import { action, makeAutoObservable, runInAction } from "mobx";
import { NotificationResultLog } from "../data/models/notificationLog";
import { Pagination } from "../data/models/pagination";
import { DateRange } from "../data/models/stats";
import agent from "../utils/agent";
import { store } from "./store";

export default class NotificationLogsStore {
    logs: Map<string, NotificationResultLog> | undefined = new Map<string, NotificationResultLog>();
    loading: boolean = false;
    searchQuery: string = '';

    constructor() {
        makeAutoObservable(this);
    }

    get logList() {
        const logList = Array.from(this.logs!.values());
        return logList.flat();
    }

    get search() {
        return this.searchQuery;
    }

    set search(value: string) {
        this.searchQuery = value;
    }
    clearLogs() {
        this.logs?.clear();

    }

    getNotificationLogs = async (queryParams: { paging: Pagination }, selectedInstitution: string | null, dateRange?: DateRange, clearLogs?: boolean) => {
        store.loadingStore.startLoading(this.getNotificationLogs);
        this.loading = true;
        try {

            const logsResponse = await agent.NotificationLogs.get(queryParams, selectedInstitution, dateRange, this.search);
            store.commonStore.setNotificationLogPagination(JSON.stringify(logsResponse.pagination));

            runInAction(() => {
                if (clearLogs) {
                    this.clearLogs();
                }
                logsResponse.data.forEach((log) => {
                    this.logs?.set(log.id, log);
                });
            });
        } catch (error) {
            throw error;
        }
        finally {
            this.loading = false;
            store.loadingStore.stopLoading(this.getNotificationLogs);
        }
    };

    reset() {
        this.logs?.clear();
        this.loading = false;
    }
}
